import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Goes to the page the user actually came from; falls back to `to` on a fresh load.
export default function BackLink({ to, label, className = "", testId = "back-link" }) {
  const nav = useNavigate();
  const location = useLocation();
  const go = () => (location.key !== "default" ? nav(-1) : nav(to));
  return (
    <button type="button" onClick={go} data-testid={testId}
      className={`inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-brand-muted hover:text-brand-ink ${className}`}>
      <ArrowLeft className="h-3.5 w-3.5" /> {label}
    </button>
  );
}
